import Api from "./singleton/api";
import View from "./public/view";
import Utils from "./public/utils";
import User from "./public/user";
import Sms from "./public/sms";
import Scheduler from "./public/scheduler";
import Rollup from "./public/rollup";
import Relation from "./public/relation";
import Record from "./public/record";
import PublicTable from "./public/public-table";
import PublicForm from "./public/public-form";
import PublicApi from "./public/public-api";
import Planning from "./public/planning";
import PdfTemplate from "./public/pdf-template";
import Notification from "./public/notification";
import Module from "./public/module";
import List from "./public/list";
import Language from "./public/language";
import Formula from "./public/formula";
import Format from "./public/format";
import Field from "./public/field";
import Feedback from "./public/feedback";
import Extras from "./public/extras";
import Excel from "./public/excel";
import Enum from "./public/enum";
import Entity from "./public/entity";
import Email from "./public/email";
import Documents from "./public/documents";
import DataExport from "./public/data-export";
import DataConnection from "./public/data-connection";
import Collection from "./public/collection";
import Card from "./public/card";
import Auth from "./public/auth";
import Application from "./public/application";
import adminInit from "./admin";

export default {
    Version: {

        get: function (): string {
            return require('../package.json').version;
        },

        api: function (): string {
            return Api.getVersion();
        }

    },
    FLapp: Api.app,
    FLapi: Api.api,
    FLusr: Api.usr,
    Auth,
    User,
    Application,
    Entity,
    Notification,
    Documents,
    Field,
    Module,
    Card,
    Rollup,
    Email,
    Sms,
    PublicTable,
    PublicForm,
    PublicApi,
    Format,
    List,
    Planning,
    View,
    Formula,
    Collection,
    Record,
    Relation,
    Language,
    Excel,
    DataExport,
    Feedback,
    Scheduler,
    Utils,
    Extras,
    Enum,
    PdfTemplate,
    DataConnection,
    adminInit
};